<template>
  {{ readTime }}
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
  html: {
    type: String,
    required: true,
  },
});

const readTime = computed(() => {
  const text = JSON.stringify(props.html).replace(/<[^>]*>/g, ' ');
  const words = text.trim().split(/\s+/).length;
  const wordsPerMinute = 200;
  const minutes = Math.ceil(words / wordsPerMinute);
  return `${minutes}´`;
});
</script>
